module.exports = __webpack_public_path__ + "media/components/assets/industry_network_photo-24346deb45399d067e6e5aadc8474568.png";